import React from 'react'
import { Result } from 'antd'
import Button from 'design-system/button'
import { ButtonSizes } from 'design-system/button/src/Button'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import styles from './index.module.scss'

const Error404: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <div className={styles.container}>
      <Result
        status="404"
        title="404"
        subTitle={t('errorPages.404.title')}
        extra={
          <Button size={ButtonSizes.Small} onClick={() => history.push('/')}>
            {t('errorPages.buttons.backHome')}
          </Button>
        }
      />
    </div>
  )
}

export default Error404
